import React, { Fragment } from 'react';
import { Transition } from '@headlessui/react';
import { formatAsCurrency } from '../../utils/formatAsCurrency';

import { calculatePartsTotal } from '../../utils/calculateFee';

export default function FeeTable({ order, orderDetails, isDarOrder, orderSubtotal, isShowing }) {
    const partsTotal = calculatePartsTotal(order);

    return (
        <div className=''>
            <Transition
                as={Fragment}
                show={isShowing}
                enter='transform transition duration-[00ms]'
                enterFrom='opacity-0 scale-50'
                enterTo='opacity-100  scale-100'
                leave='transform duration-75 transition ease-in'
                leaveFrom='opacity-100 scale-100 '
                leaveTo='opacity-0 scale-100 '
            >
                <div>
                    <div className='flex justify-end pt-4 w-full'>
                        <table className='mb-6 w-1/3 table-auto'>
                            <thead>
                                <tr>
                                    <th className='px-4 py-2 border'>Fee</th>
                                    <th className='px-4 py-2 border'>Amount</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr className=''>
                                    <td className='px-4 py-2 border'>Parts total</td>
                                    <td className='px-4 py-2 border'>{formatAsCurrency(partsTotal.toFixed(2))}</td>
                                </tr>

                                {isDarOrder && (
                                    <tr className=''>
                                        <td className='px-4 py-2 border'>DAR Fee</td>
                                        <td className='px-4 py-2 border'>{formatAsCurrency(orderDetails.totalDarFee)}</td>
                                    </tr>
                                )}

                                {orderDetails.isAOG ? (
                                    <>
                                        <tr className=''>
                                            <td className='px-4 py-2 border'>AOG Fee (Courier Only)</td>
                                            <td className='px-4 py-2 border'>{formatAsCurrency(orderDetails.AOGFee)}</td>
                                        </tr>
                                    </>
                                ) : null}
                                {orderDetails.totalMinOrderFee >= orderDetails.minOrder &&
                                    isShowing &&
                                    orderDetails.minOrder > 0 && (
                                        <tr className=''>
                                            <td className='px-4 py-2 border'>
                                                Minimum Order Surcharge{' '}
                                                {orderDetails.totalMinOrderFee - partsTotal > orderDetails.minOrder
                                                    ? '(AOG)'
                                                    : ''}
                                            </td>
                                            <td className='px-4 py-2 border'>
                                                {formatAsCurrency(orderDetails.totalMinOrderFee - partsTotal.toFixed(2))}
                                            </td>
                                        </tr>
                                    )}

                                <tr className='bg-gray-100'>
                                    <td className='px-4 py-2 font-semibold border'>Sub Total</td>
                                    <td className='px-4 py-2 font-semibold border'>
                                        {formatAsCurrency(orderSubtotal.toFixed(2))}
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            </Transition>
        </div>
    );
}
